// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0c0f16;
  --text: #eef1f6;
  --muted: #8b94a7;
  --accent: #38e0b0;
  --border: #1e2432;
}

* { box-sizing: border-box; }

html, body, #root { height: 100%; }

body {
  margin: 0;
  background:
    radial-gradient(1200px 600px at 70% -10%, rgba(56, 224, 176, 0.07), transparent 60%),
    var(--bg);
  color: var(--text);
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont,
    'Segoe UI', 'Noto Sans KR', sans-serif;
  line-height: 1.6;
}

.page {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.hero {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 48px 24px;
}

.spark {
  width: min(320px, 70vw);
  margin-bottom: 8px;
}

.spark-line {
  stroke: var(--accent);
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 420;
  stroke-dashoffset: 420;
  animation: draw 1.6s ease-out forwards;
}

.spark-dot {
  fill: var(--accent);
  opacity: 0;
  animation: appear 0.4s ease-out 1.4s forwards;
}

@keyframes draw { to { stroke-dashoffset: 0; } }
@keyframes appear { to { opacity: 1; } }

.wordmark {
  margin: 0;
  font-size: clamp(2.6rem, 9vw, 4.4rem);
  font-weight: 800;
  letter-spacing: -0.03em;
}

.wordmark .trend { color: var(--accent); }

/* About과 Trend가 공유하는 T — 두 색을 반씩 물려받는다 */
.wordmark .shared-t {
  background: linear-gradient(135deg, var(--text) 30%, var(--accent) 70%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.tagline {
  margin: 8px 0 0;
  font-size: clamp(1rem, 3vw, 1.25rem);
  color: var(--text);
}

.sub {
  margin: 2px 0 0;
  font-size: 0.9rem;
  color: var(--muted);
}

.status {
  margin-top: 40px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: var(--muted);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 10px 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.status .platforms { color: var(--text); }

.pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--accent);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(56, 224, 176, 0.5); }
  50% { box-shadow: 0 0 0 7px rgba(56, 224, 176, 0); }
}

.footer {
  display: flex;
  justify-content: center;
  gap: 24px;
  padding: 24px;
  font-size: 0.8rem;
  color: var(--muted);
}

.footer a {
  color: var(--muted);
  text-decoration: none;
}

.footer a:hover { color: var(--text); }
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B,oBAAoB,YAAY,EAAE;;AAElC;EACE,SAAS;EACT;;aAEW;EACX,kBAAkB;EAClB;0CACwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,6CAA6C;AAC/C;;AAEA,kBAAkB,KAAK,oBAAoB,EAAE,EAAE;AAC/C,oBAAoB,KAAK,UAAU,EAAE,EAAE;;AAEvC;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,mBAAmB,oBAAoB,EAAE;;AAEzC,yCAAyC;AACzC;EACE,uEAAuE;EACvE,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA,qBAAqB,kBAAkB,EAAE;;AAEzC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kBAAkB,kBAAkB,EAAE","sourcesContent":[":root {\n  --bg: #0c0f16;\n  --text: #eef1f6;\n  --muted: #8b94a7;\n  --accent: #38e0b0;\n  --border: #1e2432;\n}\n\n* { box-sizing: border-box; }\n\nhtml, body, #root { height: 100%; }\n\nbody {\n  margin: 0;\n  background:\n    radial-gradient(1200px 600px at 70% -10%, rgba(56, 224, 176, 0.07), transparent 60%),\n    var(--bg);\n  color: var(--text);\n  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont,\n    'Segoe UI', 'Noto Sans KR', sans-serif;\n  line-height: 1.6;\n}\n\n.page {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.hero {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 48px 24px;\n}\n\n.spark {\n  width: min(320px, 70vw);\n  margin-bottom: 8px;\n}\n\n.spark-line {\n  stroke: var(--accent);\n  stroke-width: 3;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 420;\n  stroke-dashoffset: 420;\n  animation: draw 1.6s ease-out forwards;\n}\n\n.spark-dot {\n  fill: var(--accent);\n  opacity: 0;\n  animation: appear 0.4s ease-out 1.4s forwards;\n}\n\n@keyframes draw { to { stroke-dashoffset: 0; } }\n@keyframes appear { to { opacity: 1; } }\n\n.wordmark {\n  margin: 0;\n  font-size: clamp(2.6rem, 9vw, 4.4rem);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n}\n\n.wordmark .trend { color: var(--accent); }\n\n/* About과 Trend가 공유하는 T — 두 색을 반씩 물려받는다 */\n.wordmark .shared-t {\n  background: linear-gradient(135deg, var(--text) 30%, var(--accent) 70%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n\n.tagline {\n  margin: 8px 0 0;\n  font-size: clamp(1rem, 3vw, 1.25rem);\n  color: var(--text);\n}\n\n.sub {\n  margin: 2px 0 0;\n  font-size: 0.9rem;\n  color: var(--muted);\n}\n\n.status {\n  margin-top: 40px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  color: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 10px 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.status .platforms { color: var(--text); }\n\n.pulse {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--accent);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(56, 224, 176, 0.5); }\n  50% { box-shadow: 0 0 0 7px rgba(56, 224, 176, 0); }\n}\n\n.footer {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  padding: 24px;\n  font-size: 0.8rem;\n  color: var(--muted);\n}\n\n.footer a {\n  color: var(--muted);\n  text-decoration: none;\n}\n\n.footer a:hover { color: var(--text); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
